import { createReducer, createSelector, on } from '@ngrx/store';
import { AppActions } from '../actions';
import { AppModel } from '../shared/models/AppModel';

export interface State {
  applicantSourceId: number | null;
  appModel: AppModel;
}

export const initialState: State = {
  applicantSourceId: null,
  appModel: null
};

export const appReducer = createReducer(
  initialState,
  on(AppActions.initialized, (state, action) => {
    return {
      ...state,
      appModel: action.appModel
    };
  }),
  on(AppActions.applicantSourceSet, (state, action) => {
    return {
      ...state,
      applicantSourceId: action.id
    };
  })
);

export const selectApplicantSourceId = (state: State) => state.applicantSourceId;
export const selectAppModel = (state: State) => state.appModel;
export const selectFeatureFlagClientKey = createSelector(
  selectAppModel,
  x => x.featureFlagClientKey
);
